/**
 * Simple one-shot pub/sub for task refinement results.
 *
 * The input bar opens the task modal immediately with a heuristic
 * fallback, then sends `task.refine.request` over the canvas WebSocket.
 * When `task.refined` arrives, the canvas page calls `resolveRefine`,
 * which notifies the modal listener (registered via `onRefine`).
 *
 * Listeners are one-shot — they auto-unregister on first call. A manual
 * unsubscribe is returned so the modal can clean up if it closes before
 * a result arrives.
 */

export interface RefineResult {
  title: string;
  description: string;
  ok: boolean;
}

type Listener = (result: RefineResult) => void;

const listeners = new Map<string, Listener>();

export function onRefine(requestId: string, cb: Listener): () => void {
  listeners.set(requestId, cb);
  return () => {
    listeners.delete(requestId);
  };
}

export function resolveRefine(requestId: string, result: RefineResult): void {
  const cb = listeners.get(requestId);
  if (cb) {
    listeners.delete(requestId);
    cb(result);
  }
}
